'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { getUrlWithSize } from '../../../../utils/urls';
import Storeys from '../../../../classes/common/storeys';

class BaseListItem extends React.Component {
  constructor (props) {
    super(props);

    this.item = props.item;
    this.rawItem = props.rawItem;

    this.property = this.item.getProperty();
    this.location = this.property.getGeoLocation();
    this.room = this.property.getRoom();
    this.className = this.item.getServices().map(v => v.alias).join(' ');
  }

  getHeader () {
    const type = this.property.getType();
    const totalArea = this.room.getTotalArea();
    const landArea = this.property.getLandPlot().getTotalArea();

    this.floor = this.room.getFloorNumber();
    this.totalFloors = this.property.getBuilding().getFloorsNumberAboveGround();
    const storeys = new Storeys();

    const body = [
      type ? type.get('middleName') : null,
      totalArea ? 'пл. ' + totalArea.getLabel(false) : null,
      landArea ? 'уч. ' + landArea.getLabel(false) : null,
      storeys.getLabel(Storeys.TYPE_SHORT)
    ].filter(Boolean).join(', ');

    return (
      <div>{body}</div>
    );
  }

  getBody () {
    const building = this.property.getBuilding();

    const isNewBuilding = building.getLabelNewBuilding() ? (
      <div key='new-build' className='new-build'>
        <span className='is-new'>{building.getLabelNewBuilding()}</span>
        { building.getDeliveryDateLabel() ? <span className='quarter'> - {building.getDeliveryDateLabel()}</span> : null }
      </div>
    ) : null;

    const street = this.location.getStreet() && this.location.getStreet().fullName;
    const houseName = this.location.getBuilding() && this.location.getBuilding().name;
    return [
      isNewBuilding,
      <div key='street'>{[street, houseName].filter(Boolean).join(' ')}</div>
    ];
  }

  getFooter () {
    return (
      <div className='price'>{this.item.getPrice().getLabel()}</div>
    );
  }

  render () {
    return (
      <div className={'realty-item ' + this.className}>
        <a className='link' onClick={() => this.props.eventClickAnnouncement(this.rawItem)} href={this.item.getLink()} target='_blank'>
          <table className='table table-no-bordered'>
            <tbody>
              <tr className={this.className}>
                <td className='td-photo'>
                  {
                    this.item.getMainPhoto()
                      ? <img className='photo' src={getUrlWithSize(this.item.getMainPhoto(), '120x120')} />
                      : <div className='no-photo'>нет фото</div>
                  }
                </td>
                <td className='text-align-top'>
                  <div className='content'>
                    <div className='header'>{this.getHeader()}</div>
                    <div className='body'>{this.getBody()}</div>
                    <div className='footer'>{this.getFooter()}</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </a>
      </div>
    );
  }
}

BaseListItem.propTypes = {
  item: PropTypes.object.isRequired,
  rawItem: PropTypes.object.isRequired,
  eventClickAnnouncement: PropTypes.func.isRequired
};

export default BaseListItem;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/ListItems/BaseListItem.jsx